import { render, staticRenderFns } from "./main-dashboard.vue?vue&type=template&id=465d0177&scoped=true&"
import script from "./main-dashboard.component.ts?vue&type=script&lang=ts&"
export * from "./main-dashboard.component.ts?vue&type=script&lang=ts&"
import style0 from "./main-dashboard.scss?vue&type=style&index=0&id=465d0177&lang=scss&scoped=true&"
import style1 from "./main-dashboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465d0177",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('465d0177')) {
      api.createRecord('465d0177', component.options)
    } else {
      api.reload('465d0177', component.options)
    }
    module.hot.accept("./main-dashboard.vue?vue&type=template&id=465d0177&scoped=true&", function () {
      api.rerender('465d0177', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-v2/main-dashboard/main-dashboard.vue"
export default component.exports